import styled from '@emotion/styled';
import { Flex, Select, Tag } from 'antd';

export const Filters = styled(Flex)`
  width: 100%;
  margin-bottom: 16px;
`;

// Cast back to the generic Select so callers keep typed value/onChange; styled()
// erases the component's generic call signature.
export const TypeSelect = styled(Select)`
  width: 200px;
` as unknown as typeof Select;

export const PaginationRow = styled(Flex)`
  margin-top: 16px;
`;

export const Channel = styled(Tag)`
  margin-left: 8px;
`;

export const Event = styled(Flex)`
  width: 100%;
  padding: 14px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSecondary};
`;

export const Date = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const Target = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black};
`;

export const Meta = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const Diff = styled(Flex)`
  width: 100%;
`;

export const Empty = styled.div`
  padding: 32px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.gray};
`;
